import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=bfbd6738&scoped=true&"
import script from "./MenuForm.vue?vue&type=script&lang=js&"
export * from "./MenuForm.vue?vue&type=script&lang=js&"
import style0 from "./MenuForm.vue?vue&type=style&index=0&id=bfbd6738&scoped=true&lang=css&"
import style1 from "./MenuForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbd6738",
  null
  
)

export default component.exports